import { applicationName } from '../applicationName';
import { useDocumentTitle } from '../hooks';
function DocumentTitle({
  title
}) {
  useDocumentTitle(title || applicationName);
  return null;
}
export default DocumentTitle;